export default "__VITE_ASSET__RUHh0El5__"